export function isMobile(){
  return useNuxtApp().$vuetify.display.mobile.value
}

export const selectOptionsWhiteBackground = {
  contentProps: {
    style: 'background-color: white'
  }
}